export default "__VITE_ASSET__BGiMvCPZ__"